import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=798dbfae&scoped=true"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=798dbfae&prod&lang=less&scoped=true"
import style1 from "./checkbox.vue?vue&type=style&index=1&id=798dbfae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798dbfae",
  null
  
)

export default component.exports